import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface TemplateFieldProps extends FormlyFieldProps { }

@Component({
  selector: 'template-field',
  standalone: true,
  imports: [...FORM_IMPORTS],
  template: `
    <div [innerHTML]="formControl.value"></div>
  `,
})
export class TemplateFieldType extends FieldType<
  FieldTypeConfig<TemplateFieldProps>
> {

}
